<template>
    <v-container>
        <v-card class="pl-10 pr-10">
            <v-card-title class="pb-0">
                <b>ตั้งเบิก</b>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <UserBranchDropdown :pageCode="pageCode" @onUserBranchChange='setCurrentBranch'></UserBranchDropdown>
            </v-card-title>
            <v-divider></v-divider>
            <v-tabs v-model="currTab" background-color="primary" color="deep-purple accent-4" dark >
                <v-tab key="TabCloseService"> จบงานซ่อม </v-tab>
                <v-tab key="TabWithdraw"> รายการตั้งเบิก </v-tab>
                 <v-tab key="TabCloseJob"> จบงานได้รับเงิน </v-tab>
            </v-tabs>
            <v-tabs-items  v-model="currTab">
                 <v-tab-item key="TabCloseService">
                     <v-card flat>
                    <TabCloseService :branchCode="branchCode" @addClick="dialog = true"></TabCloseService>
                    </v-card>
                </v-tab-item>   
                <v-tab-item key="TabWithdraw">
                    <v-card flat>
                        <TabWithdraw :branchCode="branchCode" @addClick="dialog = true"></TabWithdraw>
                    </v-card>
                </v-tab-item>
                <v-tab-item key="TabCloseJob">
                    <v-card flat>
                    <TabCloseJob :branchCode="branchCode" @addClick="dialog = true"></TabCloseJob>
                    </v-card>
                </v-tab-item> 
                </v-tabs-items>
        </v-card>       
    </v-container>
</template>

<script>

import UserBranchDropdown from '@/components/Shared/UserBranchDropdown'
import TabCloseService from './TabCloseService/TabCloseService'
import TabWithdraw from './TabWithdraw/TabWithdraw'
import TabCloseJob from './TabCloseJob/TabCloseJob'

export default {
    name: 'Withdraw',
    components: {
        UserBranchDropdown,
        TabCloseService,
        TabWithdraw,
        TabCloseJob

    },
   props:["pageCode"],
    data: () => ({
        currTab: 0,
        branchCode: null
    }),
    methods: {
       setCurrentBranch(branchCode) {
            this.branchCode = branchCode;
        }
    }
}
</script>